import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';

import { analytics } from 'core/analytics';
import { MainWrapper, Center, Divider } from 'legacyComponents/styled/lib';
import { html } from 'libs/editor/serializers/html';
import { EditorStore } from 'libs/editor/store';
import { Editor } from 'libs/editor';

import { modalStore } from 'apps/modals/app';
import { StoryWrapper, Title, Article, CoverImage } from 'apps/story/styles';
import { BottomStickyWrapper, CtaButton } from 'apps/home/landing/styles';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProjectCard } from 'legacyComponents/cards/types/project';
import { StoryCard } from 'legacyComponents/cards/types/story';
import { ThreadCard } from 'legacyComponents/cards/types/thread';
import { CollectionCard } from 'legacyComponents/cards/types/collection';
import { CollectionForm } from 'apps/collection/collectionForm/index';

import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';

import Twix from 'components/Twix';
import Sticky from 'components/Sticky';

@withNamespaces()
@inject('clientStore')
@observer
export class Competiton extends React.Component {
  competitionCTA = () => {
    const { clientStore } = this.props;
    const eventName = clientStore.signedInProfile
      ? 'clicked-add-submission-competition'
      : 'clicked-join-competition';
    analytics.sendEvent(eventName);
    clientStore.routerStore.navigate('home.newProject');
  };

  render() {
    const { clientStore, appManager } = this.props;
    const { channel } = appManager;
    const { story } = channel;
    const { avatar, title, body } = story;
    const { t } = i18next;

    const src = imageSrc(
      avatar,
      story.imageFallbackPath,
      mainConf.imgSizes.story.large,
    );
    const coverImageSection = src ? [<CoverImage src={src} key='image' />] : '';

    const store = new EditorStore({
      initialValue: html.deserialize(body || '<p></p>'),
      formatting: 'advanced',
    });

    const {
      threadsConn,
      projectsConn,
      storiesConn,
      collectionsConn,
    } = appManager;

    const threads = threadsConn.arrayApp;
    const projects = projectsConn.arrayApp;
    const stories = storiesConn.arrayApp;
    const collections = collectionsConn.arrayApp;

    const competitionCTAText = 'Competition Closed';
    return (
      <>
        <MainWrapper>
          {coverImageSection}
          <Article>
            <Title>{title}</Title>
            <StoryWrapper margin='40px auto 0 auto'>
              <Editor store={store} />
            </StoryWrapper>
            <Divider width='100%' margin='20px auto 40px auto' />
          </Article>
        </MainWrapper>
        <Twix>
          <Sticky>
            <Center>
              <CtaButton
                onClick={this.competitionCTA}
                text={competitionCTAText}
                disabled
              />
            </Center>
          </Sticky>
          <BottomStickyWrapper>
            <Center>
              <CtaButton
                onClick={this.competitionCTA}
                text={competitionCTAText}
                disabled
              />
            </Center>
          </BottomStickyWrapper>
        </Twix>
        <MainWrapper marginBottom='0px'>
          <CardSection
            title={t('Submissions')}
            tooltip='New submission'
            updateHeader
            index={1}
            createHandler={() =>
              clientStore.routerStore.navigate('home.newProject')
            }
            isChannel
            ownerName=''
            cardApp={projects}
            CardComponent={ProjectCard}
            noDataCardType='project'
            gridColumns={3}
          />
        </MainWrapper>
        <MainWrapper marginBottom='40px'>
          <CardSection
            title={t('Stories')}
            tooltip='Create new story'
            updateHeader
            index={2}
            createHandler={() =>
              clientStore.routerStore.navigate('home.newStory')
            }
            isChannel
            ownerName=''
            cardApp={stories}
            CardComponent={StoryCard}
            noDataCardType='story'
            gridColumns={2}
          />
          <CardSection
            title={t('Threads')}
            subTitle={' '}
            updateHeader
            index={0}
            isChannel
            ownerName=''
            cardApp={threads}
            CardComponent={ThreadCard}
            noDataCardType='forumThreads'
          />
          <CardSection
            title={t('Collections')}
            tooltip='Create new collection'
            updateHeader
            index={3}
            createHandler={() => modalStore.SetModalComponent(CollectionForm)}
            isChannel
            ownerName=''
            cardApp={collections}
            CardComponent={CollectionCard}
            noDataCardType='collection'
            gridColumns={3}
          />
        </MainWrapper>
      </>
    );
  }
}

Competiton.propTypes = {
  appManager: PropTypes.object,
  params: PropTypes.object,
  clientStore: PropTypes.object,
};
